<!--
     <DictInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
-->

<template>
  <div id="qmkey_dict_input">
    <v-input
      hideDetails
      :value="props.value"
      :rules="rules"
    >
      <v-menu
        v-model="see_values"
        offset-y
        :close-on-content-click="false"
        :close-on-click="false"
      >
        <template v-slot:activator="{on, attrs}">
          <div class="qmkey-dict-input-labels pa-4 v-text-field--outlined">
            <fieldset  class="qmkey-dict-input-fieldset text--primary" :class="!!props.disabled || !!props.readonly ? 'qmkey-dict-input-readonly' : ''" color="primary">
              <legend class="qmkey-fieldset-legend qmkey-dictinput-fieldset text--primary" :class="[props.readonly ? 'qmkey-dict-input-readonly' : '']">
                <span style="color: red;" v-if="props.required" class="qmkey-dict-input-readonly">*</span>
                <span>{{props.label}}</span>
              </legend>
            </fieldset>

            <slot name="key_items">
              <v-select
                v-if="props.select_key"
                :value="new_key"
                :items="available_keys"
                :disabled="!!props.disabled || !!props.readonly || available_keys.length <= 0"
                :readonly="props.readonly"
                item-text="1"
                item-value="0"
                @change="update_key"
              >

              </v-select>
              <v-text-field
                v-else
                :value="new_key"
                placeholder="Key"
                style="width: 20%;"
                dense
                id="qmkey_dict_key_input"
                @error="error_state"
                :readonly="!!props.readonly"
                :disabled="!!props.disabled || !!props.readonly"
                :hideDetails="!!props.hide_details"
                @change="update_key"
              />
            </slot>

            <span class="pa-2">:</span>
            

            <slot name="value_items">
              <v-select
                v-if="props.select_value"
                :value="new_value"
                :items="available_values"
                :disabled="!!props.disabled || !!props.readonly || available_values.length <= 0"
                :readonly="props.readonly"
                item-text="1"
                item-value="0"
                @change="update_value"
              >

              </v-select>
              <v-text-field
                v-else
                :value="new_value"
                placeholder="Value"
                style="width: 70%;"
                dense
                id="qmkey_dict_value_input"
                :readonly="!!props.readonly"
                :disabled="!!props.disabled || !!props.readonly"
                :hideDetails="!!props.hide_details"
                @error="error_state"
                @change="update_value"
              />
            </slot>
            
            <v-btn
              :disabled="!new_key"
              icon
              rounded
              @click="add_new_pair(new_key,new_value)"
              v-if="!props.readonly && !props.disabled"
            >
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-icon
              v-bind="attrs"
              v-on="on"
              :disabled="Object.entries(props.value || {}).length <= 0"
              @click="see_values = !see_values"
              id="activate_button"
            >
              mdi-menu-down
            </v-icon>
          </div>
        </template>

        <!-- CONTENT -->
        <v-list>
          <v-list-item
            v-for="[key,value] in Object.entries(props.value || {})"
            :key="key"
            :id="'qmkey_dict_list:'+key"
            class="qmkey-dictinput-list-item"
          >
            <v-row>
              <v-col cols="4" class="font-weight-black">{{ get_readable_from_entries(props.key_items, key) }}</v-col>
              <v-col cols="7">{{ get_readable_from_entries(props.value_items, value) }}</v-col>
              <v-btn v-if="!props.readonly && !props.disabled" icon @click="delete_prop(key)" class="qmkey-dictinput-list-item"><v-icon>mdi-close</v-icon></v-btn>
            </v-row>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-input>
  </div>
</template>

<style lang="scss">
  @import '@/sass/modalform.scss';
  .qmkey-dict-input-labels {
    width: 100%;
display: flex; align-items: center; height: 40px;
    label {
      background-color: white;
      padding: 4px;
    }
    input {
      font-size: 14px;
    }
    .qmkey-fieldset-legend {
      font-size: 12px;
    }

    .v-input__slot::before {
      border-top-width: 0px;
    }

  }
  .qmkey-dict-input-fieldset {
    border-radius: 4px;
    border-color: var(--v-primary-base) !important;

    .qmkey{
      color: var(--v-primary-base) !important;
    }
    legend {
      background-color: transparent !important;
    }
  }

  .qmkey-dict-input-readonly{

    border-color: rgba(0, 0, 0, 0.38)!important;
    background-color: rgba(0, 0, 0, 0.10)!important;
  }
</style>

<script>
  import DeleteButton from '@/components/DeleteButton';

export default {
  name: 'DictInput',

  components: {
    DeleteButton
  },

  props: {
    'props': {default: ()=>({})},
  },

  data: () => ({
    valid: true,
    show: true,
    see_values: false,
    new_key: null,
    new_value: null,
    blured: true,
  }),

  computed: {
    value() {
      return JSON.stringify(this.props.value) || null;
    },

    rules() {
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },

    available_keys() {
      const used = (Object.keys(this.props.value || {}));
      return (this.props.key_items || []).filter(it => !used.includes(it[0]));
    },

    available_values() {
      const used = (Object.values(this.props.value || {}));
      return (this.props.value_items || []).filter(it => !used.includes(it[0]));
    },
  },

  mounted(){
    this.add_events();
  },

  methods: {
    add_events() {
      const input = document.getElementById("qmkey_dict_input");
      const button = document.getElementById("activate_button");
      const valid_ids = ['qmkey_dict_key_input','qmkey_dict_value_input'];
      
      input.addEventListener(
        "blur",
        (event) => {
          const related_element = (event.relatedTarget || {})
          if (
            this.blured &&
            !(
              valid_ids.includes(related_element.id) ||
              (related_element.id || '').split(':')[0] == 'qmkey_dict_list' || 
              (related_element.classList && related_element.classList.contains('qmkey-dictinput-list-item'))
            )
          ) {
            this.close_menu();
          } else if (!valid_ids.includes(related_element.id)){
            button.focus();
          }
            this.blured = true;
        },
        true,
      );

      input.addEventListener(
        "mouseup",
        (event) => {
          const related_element = (event.relatedTarget || {})
          if (valid_ids.includes((event.target || {}).id)) {
            this.blured = false;
          } else if (
              (related_element.id || '').split(':')[0] == 'qmkey_dict_list' || 
              (related_element.classList && related_element.classList.contains('qmkey-dictinput-list-item'))
            ){
            this.blured = false;
            button.focus();
          } else {
            this.blured = true;
          }
        },
        true,
      );
    },

    remove_events() {
      const input = document.getElementById("qmkey_dict_input");
      input.removeEventListener("blur");
      input.removeEventListener("mouseup");
    },

    get_value() {
      return this.serialize();
    },

    serialize() {
      return JSON.stringify(this.props.value);
    },

    validate() {
      return this.valid
    },
    is_required(value) {
      // TODO: Multilang: Change hardcoded string
      return !!value || !this.props.required || this.$vuetify.lang.translator('required_field');
    },
    error_state(ok) {
      this.valid = ok
    },
    update(value) {
      let res = value;
      if (!value || Object.entries(value).length <= 0) {
        res = null;
      }
      this.$emit('update',res);
    },

    open_menu() {
      this.see_values = true;
    },

    close_menu() {
      this.see_values = false;
    },

    update_key(key) {
      this.new_key = key;
    },

    update_value(value) {
      this.new_value = value;
    },

    add_new_pair(key,value) {
      let items = {...(this.props.value || {})};
      items[key] = value;
      document.getElementById("activate_button").focus()
      this.clear_values();
      this.update(items);
      this.see_values = !this.see_values;
      this.see_values = !this.see_values;
    },

    delete_prop(key) {
      let items = {...(this.props.value || {})}
      delete items[key];
      if (Object.entries(items).length <= 0) {
        this.close_menu();
      }
      this.update(items);
    },

    clear_values() {
      this.new_key = null;
      this.new_value = null;
    },

    get_readable_from_entries(values,key) {
      // Values has to be an entries array => [[0,1],[0,1]...]
      if (values && values.length > 0) {
        return Object.fromEntries(values)[key];
      }
      return key;
    },
  },
}
</script>
